export const filterIds = ['parameterType'] as const;
